import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { facebookAuthCallbackRequest } from '../redux/slices/integrationsSlice';
import { ENDPOINTS } from '../api/endPoints';

export const useFacebookAuth = () => {
  const dispatch = useDispatch();

  const startFacebookAuth = useCallback(async () => {
    const authorizeUrl = ENDPOINTS.integrations.authorize('facebook');
    
    if (!authorizeUrl) {
      throw new Error('Facebook authorization endpoint not configured');
    }

    sessionStorage.setItem('oauth_platform', 'facebook');
    const popup = window.open(authorizeUrl, 'facebook_oauth', 'width=600,height=700');

    if (!popup || popup.closed || typeof popup.closed === 'undefined') {
      window.location.href = authorizeUrl;
      return;
    }

    try {
      const result = await waitForAuthMessage(dispatch);
      console.log('Facebook OAuth completed:', result);
      return result;
    } catch (err) {
      console.error('Facebook auth failed:', err);
      throw err;
    }
  }, [dispatch]);

  return { startFacebookAuth };
};

function waitForAuthMessage(dispatch: any): Promise<any> {
  return new Promise((resolve, reject) => {
    const handler = (event: MessageEvent) => {
      const { type, payload } = event.data || {};

      if (type === 'facebook_AUTH_SUCCESS') {
        cleanup();
        sessionStorage.setItem('facebook_auth_just_completed', 'true');
        dispatch(facebookAuthCallbackRequest({
          ...payload,
          platform: 'facebook'
        }));
        
        resolve(payload);
      }

      if (type === 'facebook_AUTH_ERROR') {
        cleanup();
        reject(payload);
      }
    };

    const cleanup = () => {
      window.removeEventListener('message', handler);
      clearTimeout(timeout);
    };

    const timeout = setTimeout(() => {
      cleanup();
      reject('Timeout');
    }, 60000);

    window.addEventListener('message', handler);
  });
}
